import React, { useEffect, useState } from "react";
import { Divider } from "antd";
import { formatValidInput, formatValidSelect } from "../../../helpers/FormatHelper";
import DynamicSelect from "../../shared/DynamicSelect";
import DatePicker from "../../shared/DatePicker";

export function AdjustmentHeader({

  validations,
  date,
  date2,
  vaultSelected,
  vaultList,
  referenceTypeSelected,
  referenceTypeList,
  referenceIDSelected,
  currenciesList, 
  buyCurrencySelected,
  updateField,
  updateBuyCurrency
}) {
  const [referenceDate, setReferenceDate] = useState(new Date());
  const [accountingDate, setAccountingDate] = useState(new Date());
  const [referenceType, setReferenceType] = useState('');
  const [referenceID, setReferenceID] = useState('');
  const [vault, setVault] = useState(-1);
  const [buyCurrency, setBuyCurrency] = useState('');
  const [firstLoad, setFirstLoad] = useState(true);
  const today = new Date();

  const handleChangeReferenceDate = (dateValue) => {
    setReferenceDate(dateValue);
    updateField('ReferenceDate',dateValue);
  };

  useEffect(()=>{    
    const today = date? new Date(date) :new Date();
    const today2 = date2? new Date(date2) :new Date();
    today.setHours(0, 0, 0, 0);
    today2.setHours(0, 0, 0, 0);
    setReferenceDate(today);
    setAccountingDate(today2);
  },[date],[date2])

  const handleChangeAccountingDate = (dateValue) => {
    setAccountingDate(dateValue);
    updateField('AccountingDate',dateValue);
  };
  
  useEffect(()=>{
    if(buyCurrencySelected !== '')
    {
      setBuyCurrency(buyCurrencySelected);
    }
  },[buyCurrencySelected])

   useEffect(()=>{
    if(vaultSelected && vaultSelected !== -1 && vaultSelected !== '-1' && firstLoad)
    {
      if(date !== null && date !== '')
      {
        setReferenceDate(new Date(date));
      }
      if(date2 !== null && date2 !== '')
      {
        setAccountingDate(new Date(date2));
      }

      setVault(vaultSelected);  
      setReferenceType(referenceTypeSelected);
      setReferenceID(referenceIDSelected);
      setFirstLoad(false);
    }
  },[date, date2, vaultSelected, firstLoad])
  

  const dropdownReferenceTypeChangeHandler = (item) => {
    if (item.value) {
      setReferenceType(item.value);
      updateField('ReferenceType', item.value);
    }
  };

    const dropdownVaultChangeHandler = (item) => {
      if(item.value && item.value !== '-1')
      {   
        setVault(item.value);
        updateField('VaultID',item.value);
        updateField('VaultName', item.name);
      }
    }

    
  const dropdownBuyCurrencyChangeHandler = async (item) => {
      if(item.value && item.value !== '')
      {
        setBuyCurrency(item.value);
        updateBuyCurrency(item);
      }
    }

    const handleUpdateReferenceID = (event) => {
        setReferenceID(event.target.value );
        updateField('ReferenceID',event.target.value);
    };


return (
    <>
      <div className="uk-grid">
            

            <div  className="uk-width-1-2 uk-form-controls">
                <label className="uk-form-label">{'Vault:'}</label>
                <DynamicSelect
                    className={formatValidSelect(validations.VaultID)}
                    data={vaultList}
                    objValue={{value:vault}}
                    getValue={dropdownVaultChangeHandler}/>                
            </div>
            <div  className="uk-width-1-2 uk-form-controls">
                <label className="uk-form-label">{'Currency:'}</label>
                <DynamicSelect
                    className={formatValidSelect(validations.CurrencyID)}
                    listHasPlaceholder={true}
                    data={currenciesList}
                    objValue={{value:buyCurrency}}
                    disabled ={true}
                    getValue={dropdownBuyCurrencyChangeHandler}/>      
            </div>

            <div  className="uk-width-1-2 uk-form-controls">
                <label className="uk-form-label">{'Reference Type'}</label>
                <DynamicSelect
                    className={formatValidSelect(validations.ReferenceType)}
                    data={referenceTypeList}
                    objValue={{value:referenceType}}
                    getValue={dropdownReferenceTypeChangeHandler}/>      
            </div>

            <div className="uk-width-1-2 uk-form-controls">
                <label className="uk-form-label">{'Reference ID:'}</label>
                <input
                            className="uk-input"
                            type="text"
                            placeholder="Reference ID"
                            onChange={handleUpdateReferenceID}
                            value={referenceID}
                        />

            </div>

            <div className="uk-width-1-2 uk-form-controls">
                <label className="uk-form-label">{'Reference Date:'}</label>
                <DatePicker disabledDays={[0,6]} 
                    className={formatValidInput(validations.ReferenceDate)}                     
                    endDate={today}
                    onDayChange={handleChangeReferenceDate}
                    value={referenceDate}/>
            
            </div>

            <div className="uk-width-1-2 uk-form-controls">
                <label className="uk-form-label">{'Accounting Date:'}</label>
                <DatePicker disabledDays={[0,6]} 
                    //className={formatValidInput(validations.ReferenceDate)}                     
                    className={formatValidInput(true)}
                    endDate={today}
                    onDayChange={handleChangeAccountingDate}
                    value={accountingDate}/>            
            </div>
           
      </div>
      <Divider style={{marginBottom:'10px', marginTop:'10px'}}/>
    </>
  );
}

export default AdjustmentHeader